// import React, { useEffect, useState } from "react";
// import { GETEnquires, updateEnquiryStatus } from "../../../services/api/Enquires";
// import {
//     Box,
//     Typography,
//     Paper,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Chip,
//     MenuItem,
//     Select,
//     CircularProgress,
//     Avatar,
//     Grid,
//     Card,
//     CardContent,
//     Divider
// } from "@mui/material";
// import { format } from "date-fns";

// const statusColors = {
//     PENDING: "default",
//     APPROVED: "success",
//     REJECTED: "error",
//     CLOSED: "warning"
// };

// export function EnquiriesVendor() {
//     const [enquiries, setEnquiries] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const slugname = localStorage.getItem("vendorsubdomain");

//     const fetchEnquiries = async () => {
//         try {
//             setLoading(true);
//             const response = await GETEnquires(slugname);
//             if (response.success) {
//                 setEnquiries(response.enquiries);
//             } else {
//                 setError("Failed to fetch enquiries");
//             }
//         } catch (err) {
//             setError(err.message);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchEnquiries();
//     }, [slugname]);

//     const handleStatusChange = async (enquiryId, newStatus) => {
//         try {
//             const response = await updateEnquiryStatus(slugname, enquiryId, { status: newStatus });
//             if (response.success) {
//                 setEnquiries(prev => prev.map(item =>
//                     item._id === enquiryId ? { ...item, status: newStatus } : item
//                 ));
//             }
//         } catch (err) {
//             console.error("Failed to update status:", err);
//         }
//     };

//     if (loading) {
//         return (
//             <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
//                 <CircularProgress />
//             </Box>
//         );
//     }

//     if (error) {
//         return (
//             <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
//                 <Typography color="error">{error}</Typography>
//             </Box>
//         );
//     }

//     if (enquiries.length === 0) {
//         return (
//             <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
//                 <Typography variant="h6">No enquiries found</Typography>
//             </Box>
//         );
//     }

//     return (
//         <Box sx={{ p: 3 }}>
//             <Typography variant="h4" gutterBottom>
//                 Enquiries
//             </Typography>

//             <Grid container spacing={3}>
//                 <Grid item xs={12}>
//                     <Card>
//                         <CardContent>
//                             <Typography variant="h6" gutterBottom>
//                                 Summary
//                             </Typography>
//                             <Typography color="text.secondary">
//                                 Total Enquiries: {enquiries.length}
//                             </Typography>
//                         </CardContent>
//                     </Card>
//                 </Grid>

//                 <Grid item xs={12}>
//                     <Paper elevation={3} sx={{ p: 2 }}>
//                         <TableContainer>
//                             <Table>
//                                 <TableHead>
//                                     <TableRow>
//                                         <TableCell>Product</TableCell>
//                                         <TableCell>Customer</TableCell>
//                                         <TableCell>Details</TableCell>
//                                         <TableCell>Date</TableCell>
//                                         <TableCell>Status</TableCell>
//                                         <TableCell>Actions</TableCell>
//                                     </TableRow>
//                                 </TableHead>
//                                 <TableBody>
//                                     {enquiries.map((enquiry) => (
//                                         <TableRow key={enquiry._id}>
//                                             <TableCell>
//                                                 <Box display="flex" alignItems="center">
//                                                     <Avatar
//                                                         src={enquiry.product.productimages[0]?.productimage}
//                                                         alt={enquiry.product.product}
//                                                         sx={{ mr: 2 }}
//                                                     />
//                                                     <Box>
//                                                         <Typography variant="subtitle1">
//                                                             {enquiry.product.product}
//                                                         </Typography>
//                                                         <Typography variant="body2" color="text.secondary">
//                                                             Part #: {enquiry.product.partNumber}
//                                                         </Typography>
//                                                     </Box>
//                                                 </Box>
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Typography>{enquiry.name}</Typography>
//                                                 <Typography variant="body2" color="text.secondary">
//                                                     {enquiry.email}
//                                                 </Typography>
//                                                 <Typography variant="body2" color="text.secondary">
//                                                     {enquiry.phone}
//                                                 </Typography>
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Typography>Qty: {enquiry.quantity}</Typography>
//                                                 <Typography variant="body2">
//                                                     {enquiry.message}
//                                                 </Typography>
//                                             </TableCell>
//                                             <TableCell>
//                                                 {format(new Date(enquiry.createdAt), "MMM dd, yyyy HH:mm")}
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Chip
//                                                     label={enquiry.status}
//                                                     color={statusColors[enquiry.status] || "default"}
//                                                 />
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Select
//                                                     value={enquiry.status}
//                                                     onChange={(e) => handleStatusChange(enquiry._id, e.target.value)}
//                                                     size="small"
//                                                     sx={{ minWidth: 120 }}
//                                                 >
//                                                     <MenuItem value="PENDING">Pending</MenuItem>
//                                                     <MenuItem value="APPROVED">Approved</MenuItem>
//                                                     <MenuItem value="REJECTED">Rejected</MenuItem>
//                                                     <MenuItem value="CLOSED">Closed</MenuItem>
//                                                 </Select>
//                                             </TableCell>
//                                         </TableRow>
//                                     ))}
//                                 </TableBody>
//                             </Table>
//                         </TableContainer>
//                     </Paper>
//                 </Grid>
//             </Grid>
//         </Box>
//     );
// }

import React, { useState, useEffect } from "react";
import { GETEnquires, updateEnquiryStatus } from "../../../services/api/Enquires";
import {
    Box,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    MenuItem,
    Select,
    CircularProgress,
    Avatar,
    Grid,
    Card,
    CardContent,
    Divider,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    IconButton,
    Tooltip
} from "@mui/material";
import { format } from "date-fns";
import {
    Visibility as ViewIcon,
    Close as CloseIcon,
    CheckCircle as ApprovedIcon,
    Cancel as RejectedIcon,
    Lock as ClosedIcon,
    AccessTime as PendingIcon
} from "@mui/icons-material";

const statusColors = {
    PENDING: "default",
    APPROVED: "success",
    REJECTED: "error",
    CLOSED: "warning"
};

const statusIcons = {
    PENDING: <PendingIcon color="action" />,
    APPROVED: <ApprovedIcon color="success" />,
    REJECTED: <RejectedIcon color="error" />,
    CLOSED: <ClosedIcon color="warning" />
};

export function EnquiriesVendor() {
    const [enquiries, setEnquiries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const slugname = localStorage.getItem("vendorsubdomain");

    const fetchEnquiries = async () => {
        try {
            setLoading(true);
            const response = await GETEnquires(slugname);
            if (response.success) {
                setEnquiries(response.enquiries);
            } else {
                setError("Failed to fetch enquiries");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEnquiries();
    }, [slugname]);

    const handleStatusChange = async (enquiryId, newStatus) => {
        try {
            const response = await updateEnquiryStatus(slugname, enquiryId, { status: newStatus });
            if (response.success) {
                setEnquiries(prev => prev.map(item =>
                    item._id === enquiryId ? { ...item, status: newStatus } : item
                ));
                if (selectedEnquiry?._id === enquiryId) {
                    setSelectedEnquiry({ ...selectedEnquiry, status: newStatus });
                }
            }
        } catch (err) {
            console.error("Failed to update status:", err);
        }
    };

    const handleViewEnquiry = (enquiry) => {
        setSelectedEnquiry(enquiry);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <Typography color="error">{error}</Typography>
            </Box>
        );
    }

    if (enquiries.length === 0) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <Typography variant="h6">No enquiries found</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>
                Enquiries
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Card sx={{ boxShadow: "none" }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Summary
                            </Typography>
                            <Box display="flex" gap={3} flexWrap="wrap">
                                <Chip
                                    label={`Total: ${enquiries.length}`}
                                    variant="outlined"
                                    color="primary"
                                />
                                <Chip
                                    label={`Pending: ${enquiries.filter(e => e.status === 'PENDING').length}`}
                                    icon={statusIcons.PENDING}
                                    variant="outlined"
                                />
                                <Chip
                                    label={`Approved: ${enquiries.filter(e => e.status === 'APPROVED').length}`}
                                    icon={statusIcons.APPROVED}
                                    variant="outlined"
                                    color="success"
                                />
                                <Chip
                                    label={`Rejected: ${enquiries.filter(e => e.status === 'REJECTED').length}`}
                                    icon={statusIcons.REJECTED}
                                    variant="outlined"
                                    color="error"
                                />
                                <Chip
                                    label={`Closed: ${enquiries.filter(e => e.status === 'CLOSED').length}`}
                                    icon={statusIcons.CLOSED}
                                    variant="outlined"
                                    color="warning"
                                />
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Paper elevation={3} sx={{ p: 1 }}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Product</TableCell>
                                        <TableCell>Customer</TableCell>
                                        <TableCell>Quantity</TableCell>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {enquiries.map((enquiry) => (
                                        <TableRow key={enquiry._id} hover>
                                            <TableCell>
                                                <Box display="flex" alignItems="center">
                                                    <Avatar
                                                        src={enquiry.product.productimages[0]?.productimage}
                                                        alt={enquiry.product.product}
                                                        sx={{ mr: 2 }}
                                                    />
                                                    <Typography variant="subtitle1">
                                                        {enquiry.product.product}
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell>
                                                <Typography>{enquiry.name}</Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {enquiry.email}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                {enquiry.quantity}
                                            </TableCell>
                                            <TableCell>
                                                {format(new Date(enquiry.createdAt), "MMM dd, yyyy")}
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    label={enquiry.status}
                                                    color={statusColors[enquiry.status] || "default"}
                                                    icon={statusIcons[enquiry.status]}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Box display="flex" gap={1}>
                                                    <Tooltip title="View Details">
                                                        <IconButton
                                                            color="primary"
                                                            onClick={() => handleViewEnquiry(enquiry)}
                                                        >
                                                            <ViewIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Select
                                                        value={enquiry.status}
                                                        onChange={(e) => handleStatusChange(enquiry._id, e.target.value)}
                                                        size="small"
                                                        sx={{ minWidth: 120 }}
                                                    >
                                                        <MenuItem value="PENDING">Pending</MenuItem>
                                                        <MenuItem value="APPROVED">Approved</MenuItem>
                                                        <MenuItem value="REJECTED">Rejected</MenuItem>
                                                        <MenuItem value="CLOSED">Closed</MenuItem>
                                                    </Select>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grid>
            </Grid>

            {/* Enquiry Detail Dialog */}
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6">Enquiry Details</Typography>
                        <IconButton onClick={handleCloseDialog}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedEnquiry && (
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Card variant="outlined">
                                    <CardContent>
                                        <Typography variant="h6" gutterBottom>
                                            Product Information
                                        </Typography>
                                        <List>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar
                                                        src={selectedEnquiry.product.productimages[0]?.productimage}
                                                        alt={selectedEnquiry.product.product}
                                                    />
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={selectedEnquiry.product.product}
                                                    secondary={`Part #: ${selectedEnquiry.product.partNumber}`}
                                                />
                                            </ListItem>
                                            <Divider component="li" />
                                            <ListItem>
                                                <ListItemText
                                                    primary="Manufacturer"
                                                    secondary={selectedEnquiry.product.manufacturer}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Price"
                                                    secondary={`$${selectedEnquiry.product.Productprice}`}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Quantity Available"
                                                    secondary={selectedEnquiry.product.quantity}
                                                />
                                            </ListItem>
                                        </List>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Card variant="outlined">
                                    <CardContent>
                                        <Typography variant="h6" gutterBottom>
                                            Enquiry Details
                                        </Typography>
                                        <List>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Customer Name"
                                                    secondary={selectedEnquiry.name}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Email"
                                                    secondary={selectedEnquiry.email}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Phone"
                                                    secondary={selectedEnquiry.phone}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Requested Quantity"
                                                    secondary={selectedEnquiry.quantity}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Message"
                                                    secondary={selectedEnquiry.message}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Date Submitted"
                                                    secondary={format(new Date(selectedEnquiry.createdAt), "PPpp")}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Current Status"
                                                    secondary={
                                                        <Chip
                                                            label={selectedEnquiry.status}
                                                            color={statusColors[selectedEnquiry.status]}
                                                            icon={statusIcons[selectedEnquiry.status]}
                                                        />
                                                    }
                                                />
                                            </ListItem>
                                        </List>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12}>
                                <Card variant="outlined">
                                    <CardContent>
                                        <Typography variant="h6" gutterBottom>
                                            Product Specifications
                                        </Typography>
                                        <Grid container spacing={2}>
                                            {selectedEnquiry.product.descriptions.map((spec, index) => (
                                                <Grid item xs={12} sm={6} md={4} key={index}>
                                                    <Paper sx={{ p: 2 }} variant="outlined">
                                                        <Typography variant="subtitle2">{spec.name}</Typography>
                                                        <Typography>{spec.value}</Typography>
                                                    </Paper>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}